import { CopilotoAdminSettings } from "@/features/copiloto/CopilotoAdminSettings";
import { useAppShell } from "@/shell/app-shell-context";

export function CopilotoAdminRoute() {
  const { token } = useAppShell();
  return <CopilotoAdminSettings token={token} />;
}
